<template>
  <div class="WSingleImageUpload">
    <div class="placeholder" v-if="!imgSrc" @click="handleInput">
      <i class="el-icon-picture-outline"></i>
    </div>
    <div class="imageBox" v-else>
      <div
        class="float-tool-bar"
        v-if="!disabled && !formDisabledValue && imgSrc"
        @click="handleInput"
      >
        <el-button
          type="text"
          icon="el-icon-view"
          @click.stop.prevent="handleImgPreview"
        ></el-button>
        <el-button
          type="text"
          icon="el-icon-delete"
          @click.stop.prevent="handleDelete"
        ></el-button>
      </div>
      <el-image
        ref="img"
        :src="imgSrc"
        lazy
        fit="contain"
        @error="handleError(itemValue.data[0])"
        @click.native="handleImgPreview"
      >
      </el-image>
    </div>
    <input
      class="inputer"
      type="file"
      :accept="accept"
      @change="handleFileChange"
      ref="inputer"
    />
    <ImageViewer
      v-if="visible"
      ref="imageViewer"
      :previewType="previewType"
      @closed="handleClosed"
    />
  </div>
</template>

<script>
import ImageViewer from '@/components/ImageViewer'
import { downloadFile } from '@/api/largeFile.js'
import upload from './mixin/upload'
export default {
  name: 'WSingleImageUpload',
  components: {
    ImageViewer
  },
  mixins: [upload],
  props: {
    accept: {
      type: String,
      default: '*'
    },
    size: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 0
    }
  },
  computed: {
    imgSrc() {
      if (this.itemValue && this.itemValue.data && this.itemValue.data.length) {
        if (this.itemValue.data[0].id) {
          if (this.itemValue.data[0].src) {
            return this.itemValue.data[0].src
          } if (this.itemValue.data[0].id) {
            return this.itemValue.data[0].src || ''
          }
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      uploadLimit: 1
    }
  },
  mounted() {
    this.getImg()
  },
  methods: {
    handleImgPreview() {
      this.visible = true
      this.value.data.forEach(d => {
        this.$set(d, 'thumbnail', d.src)
        this.$set(d, 'src', '')
      })
      this.$nextTick(() => {
        this.$refs.imageViewer.previewAttach(this.value.data)
      })
    },
    // 删除图片
    handleDelete() {
      this.itemValue.data = []
      this.$emit('handleUpdate')
    },
    // 图片预览
    handlePreview() {
      console.log(this.$refs.img)
      this.$refs.img.clickHandler()
    },
    handleInput() {
      if (this.formDisabledValue || this.disabled) return
      this.$refs.inputer.click()
    },
    handleFileChange() {
      const inputDOM = this.$refs.inputer
      this.file = inputDOM.files[0] // 通过DOM取文件数据
      if (!this.beforeUpload(this.file)) return

      this.handleUpload([this.file])
      inputDOM.value = null
    }
  }
}
</script>

<style lang="scss">
.WSingleImageUpload {
  height: 100%;
  width: 100%;
  cursor: pointer;
  .el-image {
    cursor: pointer;
  }
}
.WSingleImageUpload .imageBox {
  height: 100%;
  width: 100%;
  position: relative;
  min-height: 45px;
  position: relative;
  &:hover .float-tool-bar {
    display: block;
  }
  .float-tool-bar {
    display: none;
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      z-index: 2;
    }
    .el-button {
      width: auto;
      color: #fff;
      margin: 0 2px;
      font-size: 20px;
      position: relative;
      z-index: 3;
      height: 100%;
    }
  }
}
.WSingleImageUpload .imageBox .el-image {
  height: 100%;
  width: 100%;
}
.WSingleImageUpload .image-slot,
.WSingleImageUpload .placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
.WSingleImageUpload .inputer {
  display: none;
}
</style>